import { BreadLabel, BreadType } from 'types/bread'

export const CONFIRM_BREAD = 'CONFIRM_BREAD'
export const confirmBreadAction = (bread: BreadType) => {
  return {
    type: 'CONFIRM_BREAD',
    payload: [bread],
  }
}

export const CONFIRM_BREAD_LABELS = 'CONFIRM_BREAD_LABELS'
export const confirmBreadLabelsAction = (breadLabels: BreadLabel[]) => {
  return {
    type: 'CONFIRM_BREAD_LABELS',
    payload: breadLabels,
  }
}

export const FETCH_BREAD = 'FETCH_BREAD'
export const fetchBreadAction = (bread: BreadType) => {
  return {
    type: 'FETCH_BREAD',
    payload: [bread],
  }
}

export const FETCH_BREAD_LABELS = 'FETCH_BREAD_LABELS'
export const fetchBreadLabelsAction = (breadLabels: BreadLabel[]) => {
  return {
    type: 'FETCH_BREAD_LABELS',
    payload: breadLabels,
  }
}

export const FETCH_BREADS = 'FETCH_BREADS'
export const fetchBreadsAction = (breads: BreadType[]) => {
  return {
    type: 'FETCH_BREADS',
    payload: breads,
  }
}

export const INIT_BREADS = 'INIT_BREADS'
export const initBreadsAction = () => {
  return {
    type: 'INIT_BREADS',
    payload: [],
  }
}

export const SET_PREV_EDITED_BREAD = 'SET_PREV_EDITED_BREAD'
export const setPrevEditedBreadAction = (breadId: string) => {
  return {
    type: 'SET_PREV_EDITED_BREAD',
    payload: breadId,
  }
}

export const TOGGLE_PRIVATE = 'TOGGLE_PRIVATE'
export const togglePrivateAction = (flag: boolean) => {
  return {
    type: 'TOGGLE_PRIVATE',
    payload: flag,
  }
}
